import { render, staticRenderFns } from "./TariffListPage.vue?vue&type=template&id=577aa18c&"
import script from "./TariffListPage.vue?vue&type=script&lang=ts&"
export * from "./TariffListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports